<template>
       
    <div class="container">
        <div class="row">           
            <!-- Purple Table -->
            <div class="col-md-4" v-for="plans in planes" v-bind:key="plans.id">
                <div :class="plans.id == 1 ? 'pricing-table purple': plans.id == 2 ?'pricing-table turquoise': plans.id == 3 ? 'pricing-table red':''">
                    <!-- Table Head -->
                    <div class="pricing-label"> {{ plans.iva == 0? 'Gratuito' : 'Incluído IVA' }}</div>
                    <h2>{{ plans.nombre }}</h2>
                    <h5>{{ plans.subtitulo }}</h5>
                    <!-- Features -->
                    <div class="pricing-features">
                        <div v-html="plans.descripcion"></div>
                    </div>
                    <!-- Price -->
                    <div class="price-tag">
                    <span class="symbol">{{ plans.moneda }}</span>
                    <span class="amount">$ {{ formatNumber( parseInt(plans.valor)) }}</span>
                    <span class="after">/mes</span>
                    </div>
                    <!-- Button -->
                     <div v-if="!plan.success && plans.id == 1">
                        <a class="price-button">Plan Actual</a>    
                     </div>
                     <div v-else>
                        <a class="price-button" v-if="plan.success && plan.data[0].plan == plans.id">Plan Actual</a>
                        <router-link :to="'/carrito/'+plans.id" class="price-button" href="#" v-else-if="plans.id != 1">Obtener</router-link>                    
                        <a class="price-button" v-else>Plan Gratuito</a>
                     </div>                    
                </div>
            </div>
            <!-- Turquoise Table -->
            <!-- <div class="col-md-4">
                <div class="pricing-table turquoise"> -->
                    <!-- Table Head -->
                    <!-- <div class="pricing-label">Incluído IVA</div>
                    <h2>Visionarios</h2>
                    <h5>¡Haz realidad tus ideas!</h5> -->
                    <!-- Features -->
                    <!-- <div class="pricing-features">
                        <div class="feature">Plataformas<span>1</span></div>
                        <div class="feature">Canales<span>1</span></div>
                        <div class="feature">Últimos Videos<span>30</span></div>
                        <div class="feature">Ideas por Video<span>25</span></div>
                        <div class="feature">Soporte<span>Correo Electrónico</span></div>
                    </div> -->
                    <!-- Price -->
                    <!-- <div class="price-tag">
                    <span class="symbol">COP </span>
                    <span class="amount">$45.000</span>
                    <span class="after">/mes</span>
                    </div> -->
                    <!-- Button -->
                    <!-- <a class="price-button" v-if="plan.success && plan.data[0].plan == 1">Plan Actual</a>
                    <router-link to="/carrito/1" class="price-button" href="#" v-else>Obtener</router-link>
                </div>
            </div> -->
            <!-- Red Table -->
            <!-- <div class="col-md-4">
                <div class="pricing-table red"> -->
                    <!-- Table Head -->
                    <!-- <div class="pricing-label">Incluído IVA</div>
                    <h2>Maestros</h2>
                    <h5>Lleva tu contenido a nuevas alturas.</h5> -->
                    <!-- Features -->
                    <!-- <div class="pricing-features">
                        <div class="feature">Plataformas<span>1</span></div>
                        <div class="feature">Canales<span>1</span></div>
                        <div class="feature">Últimos Videos<span>Todos</span></div>
                        <div class="feature">Ideas por Video<span>100</span></div>
                        <div class="feature">Soporte<span>Correo Electrónico</span></div>
                    </div> -->
                    <!-- Price -->
                    <!-- <div class="price-tag">
                    <span class="symbol">COP </span>
                    <span class="amount">$95.000</span>
                    <span class="after">/mes</span>
                    </div> -->
                    <!-- Button -->
                    <!-- <a class="price-button" v-if="plan.success && plan.data[0].plan == 2">Plan Actual</a>
                    <router-link to="/carrito/2" class="price-button" href="#" v-else>Obtener</router-link>                    
                </div>
            </div> -->
            
        </div>
    </div>      
  
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        plan: [],
        planes: []
    }),
    mounted() {
        this.obtenerPlanes();
        this.obtenerPlanActual()
    },
    methods: {     
        navegacion(menu, id_usuplataforma) {
            this.$router.push('/'+menu)
            localStorage.setItem('id_usuario_plataforma', id_usuplataforma)
        },
        formatNumber(number) {
            return number.toLocaleString('es-ES'); // Formato para separar por miles
        },
        async obtenerPlanActual() {
            return await this.axios.get(configApi+'payment/valida_plan_actual', {headers})
            .then(response => {
                this.plan = response.data
            })
        },
        async obtenerPlanes() {
            return await this.axios.get(configApi+'payment/listar_planes', {headers})
            .then(response => {
                this.planes = response.data.data
            })
        },
    }
}
</script>
<style>
body {
	background: #e6e6e6;
	font-family: Rubik;
}

.main-head {
	background: #0D1440;
	box-shadow: 0px 1px 10px -6px rgba(0, 0, 0, .15);
	padding: 1rem;
	margin-bottom: 0;
	margin-top: 5rem;
	color: #fff;
	font-weight: 500;
	text-transform: uppercase;
	border-radius: 4px;
	font-size: 16px;
}

.pricing-table {
	background: #fff;
	box-shadow: 0px 1px 10px -6px rgba(0, 0, 0, .15);
	padding: 2rem;
	border-radius: 4px;
	transition: .3s;
}

.pricing-table:hover {
	box-shadow: 0px 1px 10px -4px rgba(0, 0, 0, .15);
}

.pricing-table .pricing-label {
	border-radius: 2px;
	padding: .25rem .5rem;
	margin-bottom: 1rem;
	display: inline-block;
	font-size: 12px;
	font-weight: 500;
}

.pricing-table h2 {
	color: #3b3b3b;
	font-size: 24px;
	font-weight: 500;
}

.pricing-table h5 {
	color: #B3B3B3;
	font-size: 14px;
	font-weight: 400;
}

.pricing-table .pricing-features {
	margin-top: 2rem;
}

.pricing-table .pricing-features .feature {
	font-size: 14px;
	margin: .5rem 0;
	color: #B3B3B3;
}

.pricing-table .pricing-features .feature span {
	display: inline-block;
	float: right;
	color: #3b3b3b;
	font-weight: 500;
}

.pricing-table 	.price-tag {
	margin-top: 2rem;
	text-align: center;
	font-weight: 500;
}

.pricing-table .price-tag .symbol {
	font-size: 24px;
}

.pricing-table .price-tag .amount {
	letter-spacing: -2px;
	font-size: 40px;
}

.pricing-table .price-tag .after {
	color: #3b3b3b;
	font-weight: 500;
}

.pricing-table .price-button {
	display: block;
	color: #fff;
	margin-top: 2rem;
	padding: .75rem;
	border-radius: 2px;
	text-align: center;
	font-weight: 500;
	transition: .3s;
}

.pricing-table .price-button:hover {
	text-decoration: none;
}

.purple .pricing-label {
	background: #cad2ff;
	color: #627afe;
}

.purple .price-tag {
	color: #627afe;
}

.purple .price-button {
	background: #627afe;
}

.purple .price-button:hover {
	background: #546dfe;
}

.turquoise .pricing-label {
	background: #b9edee;
	color: #44cdd2;
}

.turquoise .price-tag {
	color: #44cdd2;
}

.turquoise .price-button {
	background: #44cdd2;
}

.turquoise .price-button:hover {
	background: #2dbcc4;
}

.red .pricing-label {
	background: #ffc4c4;
	color: #ff5e5e;
}

.red .price-tag {
	color: #ff5e5e;
}

.red .price-button {
	background: #ff5e5e;
}

.red .price-button:hover {
	background: #f23c3c;
}
</style>